import { createStore, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";
import reducers from "@/shared/components/photo_gallery/reducers";
import previewMiddleware from "@/shared/components/middleware/preview";

const middlewares = [];
middlewares.push(thunk);
middlewares.push(
  previewMiddleware.withAllowActionTypes(["INIT_CATEGORY", "INIT_GALLERY"]),
);

// eslint-disable-next-line import/no-mutable-exports
let store;
if (process.env.NODE_ENV === "development") {
  // Redux DevTools Extension
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  store = createStore(
    reducers,
    /* preloadedState, */ composeEnhancers(applyMiddleware(...middlewares)),
  );
} else {
  const createStoreWithMiddleware = applyMiddleware(...middlewares)(
    createStore,
  );
  store = createStoreWithMiddleware(reducers);
}

export default store;
